export default function($) {
  var speed = 90;
  var wrapper = $('.o-wrapper');
  var fade_button = '<div class="c-readmore__button"><button class="c-button c-button--secondary c-button--small c-readmore__link">Lire plus</button></div>';

  wrapper.each( function() {
    if ( $(this).data('ifccontent') === true ) {
      $(this).addClass('c-readmore');
      $(this).append(fade_button);
    }
  });

  $(".c-readmore__link").on( 'click', function() {
    $(this).parent().parent('.c-readmore').addClass(('c-readmore--open'));
    $(this).parent().hide();
  });
}